import * as React from 'react';
import { SVGProps } from 'react';

const SvgAreaCode = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.756 12.246h1.96v-1.932h1.26v1.932h1.96v1.288h-1.96v1.96h-1.26v-1.96h-1.96v-1.288zM15.444 18v-7.966a2.13 2.13 0 0 1-.798.882c-.355.215-.779.322-1.274.322h-.168V9.726h.07c.383 0 .714-.047.994-.14.28-.103.509-.243.686-.42s.308-.383.392-.616a2.26 2.26 0 0 0 .154-.77h1.47V18h-1.526z" />
  </svg>
);

export default SvgAreaCode;
